import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Navigate } from 'react-router-dom'

// Wrap any route that requires login
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  // ✅ MSAL redirect response in URL — wait for it to finish processing
  const isMsalRedirectInProgress = window.location.href.includes('code=') || window.location.href.includes('error=')

  if (inProgress !== InteractionStatus.None || isMsalRedirectInProgress) return null

  // MSAL done, no account found — send to login
  if (!isAuthenticated) return <Navigate to="/login" replace />

  return <>{children}</>
}
